import dayJs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayJs.extend(advancedFormat);
dayJs.extend(duration);
dayJs.extend(isBetween);
dayJs.extend(isSameOrAfter);
dayJs.extend(isSameOrBefore);
dayJs.extend(relativeTime);
dayJs.extend(utc);
dayJs.extend(timezone);

export const format = (date, fmt) => dayJs(date).format(fmt);

export const getDateParts = date => {
  const jsDate = dayJs(date);
  return {
    dayOfMonth: jsDate.date(),
    monthName: jsDate.format('MMMM'),
    time: jsDate.format('h:mm a'),
    year: jsDate.year(),
    month: jsDate.month(),
    dayOfWeek: jsDate.day(),
  };
};

export const webinarTimeDaysHoursLeft = date => {
  const toDate = dayJs(date);

  if (dayJs().isSameOrAfter(toDate)) {
    return [false, false, false, false];
  }

  const diffHour = toDate.diff(dayJs(), 'h');
  const leftDay = parseInt(diffHour / 24);
  const leftHour = diffHour % 24;
  return [leftDay > 0 && leftDay, leftDay > 0 && `Day${leftDay > 1 ? 's' : ''}`, leftHour > 0 && leftHour, leftHour && `Hour${leftHour > 1 ? 's' : ''}`];
}

export const webinarTimeDurationString = time => {
  let str = false;
  if (time > 0) {
    const [hour, min] = dayJs.duration(time, 'minute').format('H m').split(' ');
    str = `${hour > 0 ? `${hour} Hour${hour > 1 ? 's' : ''}` : ''} ${min > 0 ? `${min} Min${min > 1 ? 's' : ''}` : ''}`.trim();
  }
  return str || '0 Min';
}

export const webinarTimeCompare = (start, time) => {
  const startTime = dayJs(start);
  const endTime = startTime.add(time, 'minutes');
  const nowTime = dayJs();

  // is Live
  if (nowTime.isBetween(startTime, endTime)) {
    return 0;
  }

  // is Future
  if (nowTime.isBefore(startTime)) {
    return 1;
  }

  // is Past
  return -1;
}

export default dayJs;